export const responseBlobSubscription = {
  data: {
    type: 'Subscription',
    id: '221',
    attributes: {
      price: 0,
      status: 'active',
      date_start: '2021-12-21T07:57:02',
      date_end: '2021-12-21T07:57:02',
      auto_renew: 1,
      created_at: '2021-12-21T07:57:06.310338',
      modified_at: '2021-12-21T07:57:08.247917',
      quantity: 1,
      stripe_subscription_id: '',
      name: 'blob-mock-1',
      rabbit_payload_successful: 0,
      primary_job_id: null,
      pipeline: null,
      invalid_subscription: 0,
      invalidated_at: null,
      notified_at: null,
      canonical_name: null,
      account_id: 431,
      product_id: 46,
      product_plan_id: null,
      remote_identity_id: null,
      storage_group_id: 142,
      user_id: 398,
      history_requested: 0
    },
    relationships: {
      account: {
        data: {
          type: 'Account',
          id: '431'
        }
      },
      product: {
        data: {
          type: 'Product',
          id: '46'
        }
      },
      product_plan: {
        data: null
      },
      remote_identity: {
        data: null
      },
      storage_group: {
        data: {
          type: 'StorageGroup',
          id: '142'
        }
      },
      user: {
        data: {
          type: 'User',
          id: '398'
        }
      }
    }
  },
  included: [
    {
      type: 'StorageGroup',
      id: '142',
      attributes: {
        product_id: 46,
        name: 'blob-mock-1',
        key_name: 'bb175bbe3e81b447-blob-mock-1'
      }
    }
  ]
};